import React from "react";

const images = [
  "image_1.png",
  "image_2.png",
  "image_3.png",
  "image_5.png",
  "image_6.png",
  "image_7.png",
  "image_8.png",
  "image_9.png",
  "image_10.png",
];

const desc = [
  "Nickel ore loading process",
  "Barge full of coal, ready to set sail",
  "Nickel ore loading process",
  "Barge covered with tarpaulin to maintain nickel ore quality",
  "Barge full of nickel ore",
  "Nickel ore loading process",
  "Nickel ore loading process",
  "Barge covered with tarpaulin to maintain nickel ore quality",
  "Barge is prepared for nickel ore loading",
];

export default function Carousel() {
  return (
    <div id="carouselExampleCrossfade" className="relative" data-te-carousel-init data-te-carousel-slide>
      <div
        className="absolute inset-x-0 bottom-0 z-[2] mx-[15%] mb-4 flex list-none justify-center p-0"
        data-te-carousel-indicators
      >
        {images.map((image, index) =>
          index === 0 ? (
            <button
              key={image + index}
              type="button"
              data-te-target="#carouselExampleCrossfade"
              data-te-slide-to="0"
              data-te-carousel-active
              className="mx-[3px] box-content h-[3px] w-[30px] flex-initial cursor-pointer border-0 border-y-[10px] border-solid border-transparent bg-white bg-clip-padding p-0 -indent-[999px] opacity-50 transition-opacity duration-[600ms] ease-[cubic-bezier(0.25,0.1,0.25,1.0)] motion-reduce:transition-none"
              aria-current="true"
              aria-label="Slide 1"
            ></button>
          ) : (
            <button
              key={image + index}
              type="button"
              data-te-target="#carouselExampleCrossfade"
              data-te-slide-to={`${index}`}
              className="mx-[3px] box-content h-[3px] w-[30px] flex-initial cursor-pointer border-0 border-y-[10px] border-solid border-transparent bg-white bg-clip-padding p-0 -indent-[999px] opacity-50 transition-opacity duration-[600ms] ease-[cubic-bezier(0.25,0.1,0.25,1.0)] motion-reduce:transition-none"
              aria-label={`Slide ${index + 1}`}
            ></button>
          )
        )}
      </div>
      <div className="relative w-full overflow-hidden after:clear-both after:block after:content-['']">
        <div
          class="relative float-left -mr-[100%] w-full !transform-none opacity-0 transition-opacity duration-[600ms] ease-in-out motion-reduce:transition-none aspect-[4/3]"
          data-te-carousel-fade
          data-te-carousel-item
          data-te-carousel-active
        >
          <img src={`images/${images[0]}`} class="block w-full h-full object-cover" alt={desc[0]} />
          <div class="absolute inset-x-[15%] bottom-5 py-5 text-center text-black md:block bg-[#114F94] opacity-80 rounded-t-full">
            <p className="text-sm sm:text-xl text-white">{desc[0]}</p>
          </div>
        </div>

        <div
          class="relative float-left -mr-[100%] hidden w-full !transform-none opacity-0 transition-opacity duration-[600ms] ease-in-out motion-reduce:transition-none aspect-[4/3]"
          data-te-carousel-fade
          data-te-carousel-item
        >
          <img src={`images/${images[1]}`} class="block w-full h-full object-cover" alt={desc[1]} />
          <div class="absolute inset-x-[15%] bottom-5 py-5 text-center text-black md:block bg-[#114F94] opacity-80 rounded-t-full">
            <p className="text-sm sm:text-xl text-white">{desc[1]}</p>
          </div>
        </div>

        <div
          class="relative float-left -mr-[100%] hidden w-full !transform-none opacity-0 transition-opacity duration-[600ms] ease-in-out motion-reduce:transition-none aspect-[4/3]"
          data-te-carousel-fade
          data-te-carousel-item
        >
          <img src={`images/${images[2]}`} class="block w-full h-full object-cover" alt={desc[2]} />
          <div class="absolute inset-x-[15%] bottom-5 py-5 text-center text-black md:block bg-[#114F94] opacity-80 rounded-t-full">
            <p className="text-sm sm:text-xl text-white">{desc[2]}</p>
          </div>
        </div>

        <div
          class="relative float-left -mr-[100%] hidden w-full !transform-none opacity-0 transition-opacity duration-[600ms] ease-in-out motion-reduce:transition-none aspect-[4/3]"
          data-te-carousel-fade
          data-te-carousel-item
        >
          <img src={`images/${images[3]}`} class="block w-full h-full object-cover" alt={desc[3]} />
          <div class="absolute inset-x-[15%] bottom-5 py-5 text-center text-black md:block bg-[#114F94] opacity-80 rounded-t-full">
            <p className="text-sm sm:text-xl text-white">{desc[3]}</p>
          </div>
        </div>

        <div
          class="relative float-left -mr-[100%] hidden w-full !transform-none opacity-0 transition-opacity duration-[600ms] ease-in-out motion-reduce:transition-none aspect-[4/3]"
          data-te-carousel-fade
          data-te-carousel-item
        >
          <img src={`images/${images[4]}`} class="block w-full h-full object-cover" alt={desc[4]} />
          <div class="absolute inset-x-[15%] bottom-5 py-5 text-center text-black md:block bg-[#114F94] opacity-80 rounded-t-full">
            <p className="text-sm sm:text-xl text-white">{desc[4]}</p>
          </div>
        </div>

        <div
          class="relative float-left -mr-[100%] hidden w-full !transform-none opacity-0 transition-opacity duration-[600ms] ease-in-out motion-reduce:transition-none aspect-[4/3]"
          data-te-carousel-fade
          data-te-carousel-item
        >
          <img src={`images/${images[5]}`} class="block w-full h-full object-cover" alt={desc[5]} />
          <div class="absolute inset-x-[15%] bottom-5 py-5 text-center text-black md:block bg-[#114F94] opacity-80 rounded-t-full">
            <p className="text-sm sm:text-xl text-white">{desc[5]}</p>
          </div>
        </div>

        <div
          class="relative float-left -mr-[100%] hidden w-full !transform-none opacity-0 transition-opacity duration-[600ms] ease-in-out motion-reduce:transition-none aspect-[4/3]"
          data-te-carousel-fade
          data-te-carousel-item
        >
          <img src={`images/${images[6]}`} class="block w-full h-full object-cover" alt={desc[6]} />
          <div class="absolute inset-x-[15%] bottom-5 py-5 text-center text-black md:block bg-[#114F94] opacity-80 rounded-t-full">
            <p className="text-sm sm:text-xl text-white">{desc[6]}</p>
          </div>
        </div>

        <div
          class="relative float-left -mr-[100%] hidden w-full !transform-none opacity-0 transition-opacity duration-[600ms] ease-in-out motion-reduce:transition-none aspect-[4/3]"
          data-te-carousel-fade
          data-te-carousel-item
        >
          <img src={`images/${images[7]}`} class="block w-full h-full object-cover" alt={desc[7]} />
          <div class="absolute inset-x-[15%] bottom-5 py-5 text-center text-black md:block bg-[#114F94] opacity-80 rounded-t-full">
            <p className="text-sm sm:text-xl text-white">{desc[7]}</p>
          </div>
        </div>

        <div
          class="relative float-left -mr-[100%] hidden w-full !transform-none opacity-0 transition-opacity duration-[600ms] ease-in-out motion-reduce:transition-none aspect-[4/3]"
          data-te-carousel-fade
          data-te-carousel-item
        >
          <img src={`images/${images[8]}`} class="block w-full h-full object-cover" alt={desc[8]} />
          <div class="absolute inset-x-[15%] bottom-5 py-5 text-center text-black md:block bg-[#114F94] opacity-80 rounded-t-full">
            <p className="text-sm sm:text-xl text-white">{desc[8]}</p>
          </div>
        </div>
      </div>
      <button
        className="absolute top-0 bottom-0 left-0 z-[1] flex w-[15%] items-center justify-center border-0 bg-none p-0 text-center text-white opacity-50 transition-opacity duration-150 ease-[cubic-bezier(0.25,0.1,0.25,1.0)] hover:text-white hover:no-underline hover:opacity-90 hover:outline-none focus:text-white focus:no-underline focus:opacity-90 focus:outline-none motion-reduce:transition-none"
        type="button"
        data-te-target="#carouselExampleCrossfade"
        data-te-slide="prev"
      >
        <span className="inline-block h-8 w-8">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="h-6 w-6"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
          </svg>
        </span>
        <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
          Previous
        </span>
      </button>
      <button
        className="absolute top-0 bottom-0 right-0 z-[1] flex w-[15%] items-center justify-center border-0 bg-none p-0 text-center text-white opacity-50 transition-opacity duration-150 ease-[cubic-bezier(0.25,0.1,0.25,1.0)] hover:text-white hover:no-underline hover:opacity-90 hover:outline-none focus:text-white focus:no-underline focus:opacity-90 focus:outline-none motion-reduce:transition-none"
        type="button"
        data-te-target="#carouselExampleCrossfade"
        data-te-slide="next"
      >
        <span className="inline-block h-8 w-8">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="h-6 w-6"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
          </svg>
        </span>
        <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
          Next
        </span>
      </button>
    </div>
  );
}
